<template>
    <div @drop="onDrop" @dragover="allowDrop" id="my_sites_title" class="my_sites_title" v-on:click="toggleMySites" title="拖拽站点到此处即可添加">我的站点库</div>   
    <div class="my_sites" id="my_sites" v-show="my_sites_show">
        <div v-if="mySiteItems.length>0" class="mySiteItems" @drop="onDrop" @dragover="allowDrop">
            <div class="link_items">
                <div v-for="s_item in mySiteItems" v-bind:key="s_item.name" class="link_item">
                    <a @dragover.prevent="handleDragOver" @drop="handleDropSort" draggable="true" @dragstart="handleDragStart" :href="s_item.url" target="_blank" v-on:click="clickLink(s_item.id,1)">
                        <div>
                            <img :src="!s_item.icon?'':s_item.icon"/>
                        </div>
                        <span>{{ s_item.name }}</span>
                    </a>
                </div>
            </div>
        </div>
        <div v-else class="mySiteItems" @drop="onDrop" @dragover="allowDrop">
            <div style="color: #a8abb2;font-size: 14px;padding: 20px;">
                <div>站点列表暂无数据</div>
                <div style="margin-top: 10px;">拖拽站点到此处即可<span style="color:black">添加</span></div>
                <div style="margin-top: 55px;">站点列表中拖拽站点即可<span style="color:black">排序</span></div>
                <div style="margin-top: 50px;">拖拽站点到回收站即可<span style="color:black">删除</span></div>
            </div>
        </div>
        <div class="edit_bar">
            <div @dragover.prevent="handleDragOver" @drop="handleDrop" class="collection" title="拖拽站点到此处即可删除">
                <div style="padding: 3px 0px 0px 5px;"><img style="width: 14px;height: 14px;" src="../assets/box_white.png"/></div>
                <div style="margin-left: 5px;">回 收 站</div>
            </div>
            <div>
                <el-button color="#2486b9" type="primary" size="small" v-on:click="clear">清 空</el-button>
            </div>
        </div>
        <div class="add_bar">
            <div class="add_bar_title">自定义站点添加：</div>
            <div class="add_bar_input">
                <el-input v-model="siteName" placeholder="请输入站点名称" />
            </div>
            <div class="add_bar_input">
                <el-input v-model="siteUrl" placeholder="请输入站点链接,https://或http://开头" />
            </div>
            <div class="add_button_bar">
                <el-button color="#2486b9" type="primary" size="small" v-on:click="addSite">添 加</el-button>
                <el-button color="#2486b9" type="primary" size="small" v-on:click="reset">重 置</el-button>
                <el-button color="#2486b9" type="primary" size="small" v-on:click="close">关 闭</el-button>
            </div>
        </div>
    </div>
    
</template>

<script>
/* eslint-disable no-unused-vars */
import { ElMessage,ElMessageBox} from "element-plus";
import http from '../http.js';
    export default {
        name: 'mySitesBar',
        data(){
            return{
                browserWidth:0,
                my_sites_show:false,
                mySiteItems:[],
                siteName:"",
                siteUrl:""
            }
        },mounted () {
            this.mySiteItems = JSON.parse(localStorage.getItem('mySiteItems') || '[]');
            this.setBrowserWidth();
            window.addEventListener('resize', this.setBrowserWidth);
        },
        watch: {
            mySiteItems: {
                handler(newVal) {
                    localStorage.setItem('mySiteItems', JSON.stringify(newVal));
                },
                deep: true
            }
        },
        methods:{
            close(){
                this.my_sites_show = false;
            },
            setBrowserWidth(type){
                let main_container = document.getElementById("main_container");
                var my_sites_title = document.getElementById("my_sites_title");
                var my_sites = document.getElementById("my_sites");
                //console.log("main_container.getBoundingClientRect().right=",main_container.getBoundingClientRect().right);
                //console.log("main_container.offsetWidth=",main_container.offsetWidth);
                if(main_container != undefined && main_container != null)
                    this.browserWidth = main_container.getBoundingClientRect().right-main_container.offsetWidth;
                //console.log("this.browserWidth=",this.browserWidth);
                if(this.browserWidth>=33){
                    if(my_sites_title != undefined && my_sites_title != null)
                        my_sites_title.style.right = this.browserWidth-28 + 'px';
                }else{
                    if(my_sites_title != undefined && my_sites_title != null)
                        my_sites_title.style.right = 0 + 'px';
                }
                if(this.browserWidth>=310){
                    if(my_sites != undefined && my_sites != null)
                        my_sites.style.right = this.browserWidth-280-28 + 'px';
                }else{
                    if(my_sites != undefined && my_sites != null)
                        my_sites.style.right = this.browserWidth + 'px';
                }
            },
            handleDropSort(event){
                try {
                    const from = event.dataTransfer.getData('text');
                    var to = event.target.text;
                    if(to == undefined){
                        to = event.target.parentElement.text;
                        if(to == undefined){
                            to = event.target.parentElement.parentElement.text;
                        }
                    }
                    var fromIndex = -1;
                    var toIndex = -1;
                    var fromItem = {}
                    if(to != undefined){
                        for(var i=0;i<this.mySiteItems.length;i++){
                            if(from == this.mySiteItems[i].name){
                                fromIndex = i;
                                fromItem = this.mySiteItems[i];
                            }
                            if(to == this.mySiteItems[i].name){
                                toIndex = i;
                            }
                        }

                        if(fromIndex != toIndex && fromIndex>-1 && toIndex>-1){
                            this.mySiteItems.splice(fromIndex,1);
                            this.mySiteItems.splice(toIndex,0,fromItem);
                        }
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            handleDragOver(event) {
                event.preventDefault();
            },
            handleDrop(event) {
                event.preventDefault();
                const name = event.dataTransfer.getData('text');
                var index = -1;
                for(var i=0;i<this.mySiteItems.length;i++){
                    if(name == this.mySiteItems[i].name){
                        index = i;
                        break;
                    }
                }
                if(index>-1){
                    this.mySiteItems.splice(index,1);
                    ElMessage.success("删除成功");
                }
            },
            handleDragStart(event){
                var target = event.target;
                if(event.target.tagName == "IMG"){
                    target = event.target.parentElement.parentElement;
                }
                if(target != undefined && target.tagName == "A"){
                    event.dataTransfer.setData('text', target.text);
                }
            },
            addSite(){
                if(this.siteName != "" && this.siteUrl != ""){
                    var site = {name:this.siteName,url:this.siteUrl,id:-1,icon:""}
                    if(!this.siteUrl.startsWith("https://") && !this.siteUrl.startsWith("http://")){
                        ElMessage.warning("站点链接缺少https://或http://");
                        return;
                    }
                    var url = this.siteUrl;
                    var prefix = "https://";
                    if(url.startsWith("http://")){
                        prefix = "http://";
                    }
                    url = url.replace("https://","").replace("http://","");
                    var index = url.indexOf("/");
                    if(index>-1){
                        url = url.substring(0,index);
                    }
                    site.icon = prefix+url+"/favicon.ico";
                    try {
                        var isExists = false;
                        this.mySiteItems.forEach(item =>{
                            if(item.name == site.name){
                                isExists = true;
                            }
                        });
                        if(!isExists){
                            this.mySiteItems.push(site);
                            ElMessage.success("添加成功");
                        }else{
                            ElMessage.warning("站点已存在");
                        }
                    } catch (error) {
                        return
                    }
                }
            },
            reset(){
                this.siteName="",
                this.siteUrl=""
            },
            clear(){
                if(this.mySiteItems.length>0){
                    ElMessageBox.confirm('确定要清空所有站点吗')
                    .then(() => {
                        this.mySiteItems = []
                        localStorage.setItem('mySiteItems', []);
                    }).catch(()=>{}) 
                }
            },
            clickLink(id,type){
                http.post('/linkClick',{"id":id,"type":type})
                .then(response => {
                    
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
            toggleMySites(){
                this.my_sites_show = !this.my_sites_show;
                if(this.my_sites_show){
                    this.mySiteItems = JSON.parse(localStorage.getItem('mySiteItems') || '[]');
                }
            },
            onDrop(event){
                event.preventDefault();
                const data = event.dataTransfer.getData("text");
                try {
                    const site = JSON.parse(data);
                    var isExists = false;
                    this.mySiteItems.forEach(item =>{
                        if(item.name == site.name){
                            isExists = true;
                        }
                    });
                    if(!isExists){
                        this.mySiteItems.push(site);
                        ElMessage.success("添加成功");
                    }else{
                        ElMessage.warning("站点已存在");
                    }
                } catch (error) {
                    return
                }
            },
            allowDrop(event){
                event.preventDefault();
            },
        },
    }
</script>
<style scoped>
    .my_sites_title{
        display: block;
        background-color: #2486b9;
        border-radius:5px;
        border-top-left-radius:0px;
        border-bottom-left-radius:0px;
        color: white;
        font-size: 15px;
        position: fixed;
        width: 28px;
        top:calc(50vh - 65px);
        z-index: 999;
        cursor: pointer;
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none;    /* Firefox */
        -ms-user-select: none;     /* IE/Edge */
        user-select: none;         /* 标准语法 */
    }
    .my_sites{
        border: 1px solid #2486b9;
        position: fixed;
        top:calc(50vh - 210px);
        right: 0px;
        z-index: 888;
        background-color: rgb(240, 241, 241);
        width: 280px;
        border-radius:5px;
        padding: 5px;
        height: 420px; /* 高度根据内容自适应 */
        box-sizing: border-box; /* 防止宽度计算错误 */
    }
    .mySiteItems{
        border: 1px solid #DEE3EB;
        height: 240px;
        border-radius:5px;
    }
    .link_items{
        display: flex;
        flex-flow:row wrap;
        text-align: left;
    }
    .link_item{
        font-size: 14px;
        width: 120px;
        height: 30px;
    }

    .link_item a{
        display: flex;
        flex-direction: row;
        padding: 5px 0px 5px 10px;
    }
    .link_item a div{
        width: 16px;
        height: 16px;
        display: inline;
        margin:2px 3px 0px 0px;
    }
    .link_item a span{
        font-size: 14px;
    }
    .link_item a div img{
        width: 16px;
        height: 16px;
        vertical-align: top;
    }
    
    .mySiteItems {
        overflow-y: scroll;
    }
    .mySiteItems::-webkit-scrollbar {
        width: 4px;
    }
    .mySiteItems::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #2486b9;
    }
    .mySiteItems::-webkit-scrollbar-track {
        border-radius: 0;
        background: white;
    }
    .add_button_bar{
        text-align: right;
    }
    .edit_bar{
        display:flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-bottom: 10px;
        margin-top: 5px;
    }
    .collection{
        display: flex;
        flex-direction: row;
        background-color: #2486b9;
        color: white;
        padding: 3px 0px 2px 3px;
        font-size: 14px;
        border-radius:3px;
        width: 84px;
        margin-right: 20px;
        cursor:default;
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none;    /* Firefox */
        -ms-user-select: none;     /* IE/Edge */
        user-select: none;         /* 标准语法 */
    }
    .add_bar{
        margin-top: 10px;
    }
    .add_bar_title{
        color: #a8abb2;
        text-align: left;
        font-size: 14px;
    }
    .add_bar_input{
        margin-bottom: 5px;
        margin-top: 5px;
    }
    .add_button_bar{
        margin-bottom: 5px;
    }
</style>